module.exports = __webpack_public_path__ + "98467bdf8dad3020702e22981b9e22ed.png";